import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationMessageComponent } from 'src/app/dialogs/notification-message/notification-message.component';
import { IFavoriteReq } from 'src/app/model/http/myFavourites.model';
import { CommonService } from 'src/app/services/common.service';
import { DialogService } from 'src/app/services/dialog.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { v4 as uuidv4 } from 'uuid';
import {
  BooleanCons,
  FavoriteAddDelete,
  LineProductCons,
  MessageType,
  NumberCons,
  StringConst
} from '../../constants/const';
import { Messages } from '../../constants/messages';
import { GeneralMessage, TypeIcon } from '../../model/device/message.model';
import {
  CallPlace,
  ChangeFavorite,
  FavoriteConfig
} from '../../model/http/myActivity.model';
import { FavoritesService } from '../../services/favorites.service';
import { ObservableService } from '../../services/observable.service';
@Component({
  selector: 'app-favorite',
  templateUrl: './favorite.component.html',
  styleUrls: ['./favorite.component.scss'],
})
export class FavoriteComponent implements OnInit, OnDestroy {
  @Input() container = StringConst.empty;
  @Input() description = StringConst.empty;
  @Input() label = StringConst.empty;
  @Input() isLine = StringConst.empty;
  @Input() itemCode = StringConst.empty;
  @Input() isFavorite = BooleanCons.false;
  @Input() whoRequest: CallPlace = CallPlace.default;
  @Input() index: number | undefined;
  @Input() configFavorite = new FavoriteConfig();
  @Output() needReloadToProducts = new EventEmitter<boolean>();
  @Input() emitChangeFavorite = BooleanCons.false;
  @Input() attributeIndex = NumberCons.zero;
  @Input() showPaddingtop = BooleanCons.true;
  @Output() favoriteChangeEmitter = new EventEmitter<ChangeFavorite>();

  subscription = new Subscription();
  isPhoneView = false;
  componentId = uuidv4();
  constructor(
    private favoritesService: FavoritesService,
    private observableService: ObservableService,
    private commonService: CommonService,
    private dialogService: DialogService,
    private localStorageService: LocalStorageService,
  ) { }

  ngOnInit(): void {
    this.getResponseOfDialog();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getNewProduct(): IFavoriteReq[] {
    return [{
      cardCode: this.localStorageService.getCardCodeGeneral(),
      itemCode: this.itemCode,
      description: this.description,
      container: this.commonService.calculateTernary(this.isLine === LineProductCons.yes,
        LineProductCons.containerNoApply,
        this.container),
      label: this.commonService.calculateTernary(this.isLine === LineProductCons.yes,
        LineProductCons.noApply,
        this.label),
    }];
  }

  changeFavorite(): void {
    const action = this.commonService.calculateTernary(this.isFavorite,
      FavoriteAddDelete.delete,
      FavoriteAddDelete.add
    );
    const priceList = this.localStorageService.getPriceList();
    this.favoritesService.saveDeleteFavorite(action, this.getNewProduct(), priceList)
      .subscribe(() => {
        this.needReloadToProducts.emit(true);
        this.favoriteChangeEmitter.emit({
          indexAttribute: this.attributeIndex,
          isFavorite: !this.isFavorite
        });
        if (!this.emitChangeFavorite) {
          this.isFavorite = !this.isFavorite;
        }
        if (this.whoRequest === CallPlace.myFavourites) {
          this.deleteIndex();
        }
        if (this.whoRequest === CallPlace.detailOrderListEdit) {
          this.observableService.setChangeFavorite(!this.isFavorite);
        }
      });
  }

  deleteIndex(): void {
    this.observableService.setInfoFavourites({
      callPlace: CallPlace.myFavourites,
      index: this.index ?? 0,
    });
  }

  showConfirmationDialog(): void {
    if (this.invalidProduct()) {
      this.showContainerError();
      return;
    }
    if (this.isFavorite) {
      this.showQuestionChangeFavorite();
      return;
    }
    this.changeFavorite();
  }

  showQuestionChangeFavorite(): void {
    this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
      request: this.whoRequest,
      isButtonCancel: true,
      textToShow: Messages.deleteFromFavorites,
      typeIcon: TypeIcon.question,
      typeMessage: MessageType.myFavorites,
      wasOk: true,
      componentId: this.componentId
    });
  }

  invalidProduct(): boolean {
    return this.commonService.validateAndValue([
      this.isLine === LineProductCons.no,
      !this.commonService.validateValidString(this.container),
    ]);
  }

  showContainerError(): void {
    this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
      textToShow: Messages.invalidContainer,
      typeIcon: TypeIcon.error,
      typeMessage: MessageType.myFavorites,
    });
  }

  getResponseOfDialog(): void {
    this.subscription.add(
      this.observableService.getResultGeneralNotification().subscribe((res) => {
        if (res.componentId === this.componentId) {
          this.validateIfChangeFavorite(res);
        }
      })
    );
  }
  validateIfChangeFavorite(res: GeneralMessage): void {
    if (res.wasOk === true) {
      this.changeFavorite();
    }
  }
}
